import { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { AuthShell } from "@/pages/auth/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      navigate("/login", { state: { reset: true } });
    } catch (e2) {
      setError(errMsg(e2));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell heading="Choose a new password" sub="Minimum 8 characters.">
      {!token ? (
        <p className="text-sm text-red-700" data-testid="reset-missing-token">
          This reset link is missing its token. Please request a new one from the{" "}
          <Link to="/forgot-password" className="text-[#002FA7] hover:underline">forgot password</Link> page.
        </p>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          {error && (
            <div data-testid="reset-error" className="text-sm text-red-700 bg-red-50 border border-red-200 rounded-md px-3 py-2">
              {error}
            </div>
          )}
          <div className="space-y-1.5">
            <Label htmlFor="rp-password">New password</Label>
            <Input id="rp-password" data-testid="reset-password-input" type="password" required minLength={8}
              value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <Button type="submit" data-testid="reset-submit-btn" disabled={loading}
            className="w-full bg-slate-950 hover:bg-slate-800 text-white">
            {loading ? "Saving…" : "Set new password"}
          </Button>
        </form>
      )}
    </AuthShell>
  );
}
